/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_RespondingInputs */

const en_privacy_section_3_item_responding = /** @type {(inputs: Privacy_Section_3_Item_RespondingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responding to inquiries`)
};

const lv_privacy_section_3_item_responding = /** @type {(inputs: Privacy_Section_3_Item_RespondingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildēšana uz pieprasījumiem`)
};

/**
* | output |
* | --- |
* | "Responding to inquiries" |
*
* @param {Privacy_Section_3_Item_RespondingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_responding = /** @type {((inputs?: Privacy_Section_3_Item_RespondingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_RespondingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_responding(inputs)
	return en_privacy_section_3_item_responding(inputs)
});